import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const REGISTRIES = [
  {
    flag: '🇺🇸',
    labelKey: 'registryZolaLabel',
    subLabelKey: 'registryZolaSubLabel',
    url: 'https://www.zola.com/registry/adrienneandthomasseptember5',
    testId: 'registry-zola',
  },
  {
    flag: '🇫🇷',
    labelKey: 'registryMmmLabel',
    subLabelKey: 'registryMmmSubLabel',
    url: 'https://www.millemercismariage.com/adriennethomaslove/liste.html',
    testId: 'registry-mmm',
  },
];

export const RegistryPage = () => {
  const { t } = useLanguage();

  return (
    <section className="pt-14 pb-16 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="font-serif text-4xl sm:text-5xl text-[#2D2A26] mb-4">
            {t('registryTitle')}
          </h2>
          <div className="w-16 h-px bg-[#B5985A] mx-auto mb-8" />

          <p className="text-[#5C5A56] text-base leading-relaxed max-w-xl mx-auto mb-12">
            {t('registryIntro')}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto"
        >
          {REGISTRIES.map((registry) => (
            <a
              key={registry.testId}
              href={registry.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={registry.testId}
              className="group flex flex-col items-center text-center border border-[#E5E5E5] hover:border-[#B5985A] rounded-sm bg-white p-8 transition-all duration-200 hover:shadow-md"
            >
              <span className="text-4xl mb-3" aria-hidden="true">
                {registry.flag}
              </span>
              <h3 className="font-serif text-2xl text-[#2D2A26] mb-1">
                {t(registry.labelKey)}
              </h3>
              <p className="text-[#999] text-sm mb-5">
                {t(registry.subLabelKey)}
              </p>
              <span className="inline-flex items-center gap-1.5 text-[#B5985A] text-sm group-hover:underline">
                {t('registryOpenLink')}
                <ExternalLink className="w-3 h-3" />
              </span>
            </a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
